<section>
  <div class="first-title-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M13.5 8.65625C13.5 8.82313 13.4505 8.98626 13.3578 9.12501C13.2651 9.26377 13.1333 9.37191 12.9791 9.43577C12.825 9.49963 12.6553 9.51634 12.4916 9.48379C12.328 9.45123 12.1776 9.37087 12.0596 9.25287C11.9416 9.13487 11.8613 8.98453 11.8287 8.82086C11.7962 8.65719 11.8129 8.48754 11.8767 8.33336C11.9406 8.17919 12.0487 8.04741 12.1875 7.9547C12.3262 7.86198 12.4894 7.8125 12.6562 7.8125C12.88 7.8125 13.0946 7.90139 13.2529 8.05963C13.4111 8.21786 13.5 8.43247 13.5 8.65625ZM10.6875 5H7.875C7.72582 5 7.58274 5.05926 7.47725 5.16475C7.37176 5.27024 7.3125 5.41332 7.3125 5.5625C7.3125 5.71168 7.37176 5.85476 7.47725 5.96025C7.58274 6.06574 7.72582 6.125 7.875 6.125H10.6875C10.8367 6.125 10.9798 6.06574 11.0852 5.96025C11.1907 5.85476 11.25 5.71168 11.25 5.5625C11.25 5.41332 11.1907 5.27024 11.0852 5.16475C10.9798 5.05926 10.8367 5 10.6875 5ZM17.4375 8.375V10.625C17.4375 11.0726 17.2597 11.5018 16.9432 11.8182C16.6268 12.1347 16.1976 12.3125 15.75 12.3125H15.5841L14.4443 15.5033C14.3663 15.7218 14.2225 15.9109 14.0329 16.0446C13.8432 16.1783 13.6168 16.25 13.3847 16.25H12.4903C12.2582 16.25 12.0318 16.1783 11.8421 16.0446C11.6525 15.9109 11.5087 15.7218 11.4307 15.5033L11.2957 15.125H7.2668L7.1318 15.5033C7.05376 15.7218 6.91005 15.9109 6.72035 16.0446C6.53065 16.1783 6.30426 16.25 6.07219 16.25H5.17781C4.94574 16.25 4.71935 16.1783 4.52965 16.0446C4.33995 15.9109 4.19624 15.7218 4.1182 15.5033L3.23438 13.0311C2.39356 12.0795 1.86709 10.8915 1.72687 9.62937C1.54534 9.72472 1.39332 9.86787 1.28725 10.0433C1.18117 10.2188 1.12506 10.42 1.125 10.625C1.125 10.7742 1.06574 10.9173 0.960248 11.0227C0.854758 11.1282 0.711684 11.1875 0.5625 11.1875C0.413316 11.1875 0.270242 11.1282 0.164752 11.0227C0.0592632 10.9173 0 10.7742 0 10.625C0.000859484 10.1234 0.169328 9.63641 0.478641 9.24148C0.787954 8.84656 1.22037 8.56633 1.70719 8.44531C1.83285 6.89515 2.53689 5.44894 3.67951 4.39385C4.82213 3.33877 6.31976 2.75197 7.875 2.75H15.1875C15.3367 2.75 15.4798 2.80926 15.5852 2.91475C15.6907 3.02024 15.75 3.16332 15.75 3.3125C15.75 3.46168 15.6907 3.60476 15.5852 3.71025C15.4798 3.81574 15.3367 3.875 15.1875 3.875H13.6835C14.617 4.52996 15.3512 5.43034 15.8048 6.47656C15.8351 6.54688 15.8646 6.61719 15.8927 6.6875C16.3151 6.72335 16.7085 6.91685 16.9947 7.22951C17.281 7.54218 17.439 7.95111 17.4375 8.375ZM16.3125 8.375C16.3125 8.22582 16.2532 8.08274 16.1477 7.97725C16.0423 7.87176 15.8992 7.8125 15.75 7.8125H15.4927C15.3729 7.81263 15.2561 7.7745 15.1595 7.70368C15.0629 7.63285 14.9914 7.53303 14.9555 7.41875C14.6332 6.39031 13.9907 5.49178 13.1217 4.85428C12.2527 4.21677 11.2027 3.87365 10.125 3.875H7.875C6.89254 3.87495 5.93128 4.16077 5.10846 4.69762C4.28564 5.23446 3.6368 5.99912 3.24107 6.89837C2.84534 7.79761 2.71982 8.79257 2.87981 9.76192C3.03981 10.7313 3.4784 11.6331 4.14211 12.3575C4.19286 12.4127 4.23207 12.4775 4.25742 12.548L5.17781 15.125H6.07219L6.34078 14.3734C6.37978 14.2641 6.45158 14.1696 6.54636 14.1028C6.64114 14.036 6.75426 14.0001 6.87023 14H11.6923C11.8082 14.0001 11.9214 14.036 12.0161 14.1028C12.1109 14.1696 12.1827 14.2641 12.2217 14.3734L12.4903 15.125H13.3847L14.658 11.5609C14.697 11.4516 14.7688 11.3571 14.8636 11.2903C14.9584 11.2235 15.0715 11.1876 15.1875 11.1875H15.75C15.8992 11.1875 16.0423 11.1282 16.1477 11.0227C16.2532 10.9173 16.3125 10.7742 16.3125 10.625V8.375Z"
        fill="#0B0C0E"
      />
    </svg>
    <h1 class="heading-h1">Patrimônio</h1>
  </div>

  <div class="pdf-patrimony">
    <div class="pdf__summary-client">
      <h2 class="heading-h2">Montante patrimonial estimado:</h2>
      <p class="paragraph amount-label">
        <span class="amount-value">{{ amountFormated }} </span> (Imóveis +
        Veículos + Investimentos)
      </p>
    </div>
    <!-- ------------------------------IMOVEIS ------------------------->
    <div class="pdf-patrimony__property">
      <div class="title-property-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M15 12.9999H14V5.99992C14 5.7347 13.8946 5.48035 13.7071 5.29281C13.5196 5.10527 13.2652 4.99992 13 4.99992H9V1.99992C9.00012 1.81883 8.95106 1.64111 8.85807 1.48573C8.76507 1.33035 8.63163 1.20313 8.47199 1.11766C8.31234 1.03219 8.13248 0.991676 7.95161 1.00044C7.77073 1.0092 7.59564 1.06692 7.445 1.16742L2.445 4.49992C2.30784 4.59143 2.19543 4.71544 2.11779 4.86091C2.04015 5.00637 1.99969 5.16878 2 5.33367V12.9999H1C0.867392 12.9999 0.740215 13.0526 0.646447 13.1464C0.552678 13.2401 0.5 13.3673 0.5 13.4999C0.5 13.6325 0.552678 13.7597 0.646447 13.8535C0.740215 13.9472 0.867392 13.9999 1 13.9999H15C15.1326 13.9999 15.2598 13.9472 15.3536 13.8535C15.4473 13.7597 15.5 13.6325 15.5 13.4999C15.5 13.3673 15.4473 13.2401 15.3536 13.1464C15.2598 13.0526 15.1326 12.9999 15 12.9999ZM13 5.99992V12.9999H9V5.99992H13ZM3 5.33367L8 1.99992V12.9999H3V5.33367ZM7 6.99992V7.99992C7 8.13253 6.94732 8.2597 6.85355 8.35347C6.75979 8.44724 6.63261 8.49992 6.5 8.49992C6.36739 8.49992 6.24021 8.44724 6.14645 8.35347C6.05268 8.2597 6 8.13253 6 7.99992V6.99992C6 6.86731 6.05268 6.74013 6.14645 6.64636C6.24021 6.5526 6.36739 6.49992 6.5 6.49992C6.63261 6.49992 6.75979 6.5526 6.85355 6.64636C6.94732 6.74013 7 6.86731 7 6.99992ZM5 6.99992V7.99992C5 8.13253 4.94732 8.2597 4.85355 8.35347C4.75979 8.44724 4.63261 8.49992 4.5 8.49992C4.36739 8.49992 4.24021 8.44724 4.14645 8.35347C4.05268 8.2597 4 8.13253 4 7.99992V6.99992C4 6.86731 4.05268 6.74013 4.14645 6.64636C4.24021 6.5526 4.36739 6.49992 4.5 6.49992C4.63261 6.49992 4.75979 6.5526 4.85355 6.64636C4.94732 6.74013 5 6.86731 5 6.99992ZM5 10.4999V11.4999C5 11.6325 4.94732 11.7597 4.85355 11.8535C4.75979 11.9472 4.63261 11.9999 4.5 11.9999C4.36739 11.9999 4.24021 11.9472 4.14645 11.8535C4.05268 11.7597 4 11.6325 4 11.4999V10.4999C4 10.3673 4.05268 10.2401 4.14645 10.1464C4.24021 10.0526 4.36739 9.99992 4.5 9.99992C4.63261 9.99992 4.75979 10.0526 4.85355 10.1464C4.94732 10.2401 5 10.3673 5 10.4999ZM7 10.4999V11.4999C7 11.6325 6.94732 11.7597 6.85355 11.8535C6.75979 11.9472 6.63261 11.9999 6.5 11.9999C6.36739 11.9999 6.24021 11.9472 6.14645 11.8535C6.05268 11.7597 6 11.6325 6 11.4999V10.4999C6 10.3673 6.05268 10.2401 6.14645 10.1464C6.24021 10.0526 6.36739 9.99992 6.5 9.99992C6.63261 9.99992 6.75979 10.0526 6.85355 10.1464C6.94732 10.2401 7 10.3673 7 10.4999Z"
            fill="#CC9213"
          />
        </svg>
        <h2 class="heading-h2">Imóveis</h2>
      </div>

      <div class="property__content">
        <div class="content-grid">
          <div>
            <h3 class="heading-h3">Possui imóvel(is) próprio(s)</h3>
            <p class="paragraph">{{ property }}</p>
          </div>

          <div *ngIf="dataStoreProperty.properties" class="patrimony__grid">
            <div
              class="individual-patrimony"
              *ngFor="
                let item of dataStoreProperty.listProperties;
                let i = index
              "
            >
              <div class="anotation">
                <h3 class="heading-h3">Valor estimado</h3>
                <p class="paragraph">
                  {{ item.estimatedValue }}
                </p>
              </div>

              <div class="anotation">
                <h3 class="heading-h3">Finaciado</h3>
                <p class="paragraph">
                  {{ item.propertyFinanced ? "Sim" : "Não" }}
                </p>
              </div>

              <div class="anotation">
                <h3 class="heading-h3">Anotações</h3>
                <p class="paragraph">
                  {{ item.notes }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="page2el"></div>

    <!-- ------------------------------VEICULOS -------------------------->

    <div class="pdf-patrimony__vehicles">
      <div class="title-vehicles-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M15 7H14.325L12.5887 3.09375C12.5102 2.91702 12.382 2.76686 12.2199 2.66148C12.0577 2.55609 11.8684 2.5 11.675 2.5H4.325C4.13159 2.5 3.94233 2.55609 3.78014 2.66148C3.61796 2.76686 3.48982 2.91702 3.41125 3.09375L1.675 7H1C0.867392 7 0.740215 7.05268 0.646447 7.14645C0.552678 7.24021 0.5 7.36739 0.5 7.5C0.5 7.63261 0.552678 7.75979 0.646447 7.85355C0.740215 7.94732 0.867392 8 1 8H1.5V13C1.5 13.2652 1.60536 13.5196 1.79289 13.7071C1.98043 13.8946 2.23478 14 2.5 14H4C4.26522 14 4.51957 13.8946 4.70711 13.7071C4.89464 13.5196 5 13.2652 5 13V12H11V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14H13.5C13.7652 14 14.0196 13.8946 14.2071 13.7071C14.3946 13.5196 14.5 13.2652 14.5 13V8H15C15.1326 8 15.2598 7.94732 15.3536 7.85355C15.4473 7.75979 15.5 7.63261 15.5 7.5C15.5 7.36739 15.4473 7.24021 15.3536 7.14645C15.2598 7.05268 15.1326 7 15 7ZM4.325 3.5H11.675L13.2306 7H2.76938L4.325 3.5ZM4 13H2.5V12H4V13ZM12 13V12H13.5V13H12ZM13.5 11H2.5V8H13.5V11ZM3.5 9.5C3.5 9.36739 3.55268 9.24021 3.64645 9.14645C3.74021 9.05268 3.86739 9 4 9H5C5.13261 9 5.25979 9.05268 5.35355 9.14645C5.44732 9.24021 5.5 9.36739 5.5 9.5C5.5 9.63261 5.44732 9.75979 5.35355 9.85355C5.25979 9.94732 5.13261 10 5 10H4C3.86739 10 3.74021 9.94732 3.64645 9.85355C3.55268 9.75979 3.5 9.63261 3.5 9.5ZM10.5 9.5C10.5 9.36739 10.5527 9.24021 10.6464 9.14645C10.7402 9.05268 10.8674 9 11 9H12C12.1326 9 12.2598 9.05268 12.3536 9.14645C12.4473 9.24021 12.5 9.36739 12.5 9.5C12.5 9.63261 12.4473 9.75979 12.3536 9.85355C12.2598 9.94732 12.1326 10 12 10H11C10.8674 10 10.7402 9.94732 10.6464 9.85355C10.5527 9.75979 10.5 9.63261 10.5 9.5Z"
            fill="#C72F41"
          />
        </svg>
        <h2 class="heading-h2">Veículos</h2>
      </div>

      <div class="patrimony__content">
        <div class="content-grid">
          <div>
            <h3 class="heading-h3">Possui veículo(s)</h3>
            <p class="paragraph">{{ vehicles }}</p>
          </div>

          <div *ngIf="dataStoreVehicles.vehicles" class="vehicles__grid">
            <div
              class="individual-vehicles"
              *ngFor="let item of dataStoreVehicles.listVehicles; let i = index"
            >
              <div class="anotation">
                <h3 class="heading-h3">Tipo e modelo do veículo</h3>
                <p class="paragraph">
                  {{ item.model }}
                </p>
              </div>

              <div class="anotation">
                <h3 class="heading-h3">Ano de compra</h3>
                <p class="paragraph">
                  {{ item.yearOfPurchase }}
                </p>
              </div>

              <div class="anotation">
                <h3 class="heading-h3">Valor estimado</h3>
                <p class="paragraph">
                  {{ item.estimatedValue }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="page2el"></div>
    <!-- ------------------------------INSS ------------------------------>

    <div class="pdf-patrimony__inss">
      <div class="title-inss-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.5 3.5H11V3C11 2.60218 10.842 2.22064 10.5607 1.93934C10.2794 1.65804 9.89782 1.5 9.5 1.5H6.5C6.10218 1.5 5.72064 1.65804 5.43934 1.93934C5.15804 2.22064 5 2.60218 5 3V3.5H2.5C2.23478 3.5 1.98043 3.60536 1.79289 3.79289C1.60536 3.98043 1.5 4.23478 1.5 4.5V12.5C1.5 12.7652 1.60536 13.0196 1.79289 13.2071C1.98043 13.3946 2.23478 13.5 2.5 13.5H13.5C13.7652 13.5 14.0196 13.3946 14.2071 13.2071C14.3946 13.0196 14.5 12.7652 14.5 12.5V4.5C14.5 4.23478 14.3946 3.98043 14.2071 3.79289C14.0196 3.60536 13.7652 3.5 13.5 3.5ZM6 3C6 2.86739 6.05268 2.74021 6.14645 2.64645C6.24021 2.55268 6.36739 2.5 6.5 2.5H9.5C9.63261 2.5 9.75979 2.55268 9.85355 2.64645C9.94732 2.74021 10 2.86739 10 3V3.5H6V3ZM13.5 4.5V7.10063C11.8124 8.01924 9.92145 8.50034 8 8.5C6.07863 8.50035 4.18776 8.01947 2.5 7.10125V4.5H13.5ZM13.5 12.5H2.5V8.2275C4.21245 9.06512 6.09367 9.50037 8 9.5C9.90637 9.50004 11.7876 9.06459 13.5 8.22688V12.5ZM6.5 7C6.5 6.86739 6.55268 6.74021 6.64645 6.64645C6.74021 6.55268 6.86739 6.5 7 6.5H9C9.13261 6.5 9.25979 6.55268 9.35355 6.64645C9.44732 6.74021 9.5 6.86739 9.5 7C9.5 7.13261 9.44732 7.25979 9.35355 7.35355C9.25979 7.44732 9.13261 7.5 9 7.5H7C6.86739 7.5 6.74021 7.44732 6.64645 7.35355C6.55268 7.25979 6.5 7.13261 6.5 7Z"
            fill="#CC5120"
          />
        </svg>
        <h2 class="heading-h2">INSS</h2>
      </div>

      <div class="patrimony__content">
        <div class="content-grid">
          <div>
            <h3 class="heading-h3">Contribui para o INSS</h3>
            <p class="paragraph">{{ inss }}</p>
          </div>

          <div *ngIf="dataStoreInss.contribute">
            <h3 class="heading-h3">Quanto</h3>
            <p class="paragraph">{{ amountInssMonthFormated }} /mês</p>
          </div>

          <div *ngIf="dataStoreInss.contribute">
            <h3 class="heading-h3">
              Acredita que o INSS será suficiente para garantir a aposentadoria
              merecida
            </h3>
            <p class="paragraph">{{ inssRetirement }}</p>
          </div>

          <div>
            <h3 class="heading-h3">
              Quanto de renda passiva você deseja ter ao parar de trabalhar?
            </h3>
            <p class="paragraph">{{ amountRetirementFormated }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- ------------------------------IVESTIMENTOS ---------------------->

    <div class="pdf-patrimony__investiments">
      <div class="title-investiments-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5ZM10.5 9.25C10.5 9.71413 10.3156 10.1592 9.98744 10.4874C9.65925 10.8156 9.21413 11 8.75 11H8.5V11.5C8.5 11.6326 8.44732 11.7598 8.35356 11.8536C8.25979 11.9473 8.13261 12 8 12C7.86739 12 7.74022 11.9473 7.64645 11.8536C7.55268 11.7598 7.5 11.6326 7.5 11.5V11H6.5C6.36739 11 6.24022 10.9473 6.14645 10.8536C6.05268 10.7598 6 10.6326 6 10.5C6 10.3674 6.05268 10.2402 6.14645 10.1464C6.24022 10.0527 6.36739 10 6.5 10H8.75C8.94892 10 9.13968 9.92098 9.28033 9.78033C9.42098 9.63968 9.5 9.44891 9.5 9.25C9.5 9.05109 9.42098 8.86032 9.28033 8.71967C9.13968 8.57902 8.94892 8.5 8.75 8.5H7.25C6.78587 8.5 6.34075 8.31563 6.01257 7.98744C5.68438 7.65925 5.5 7.21413 5.5 6.75C5.5 6.28587 5.68438 5.84075 6.01257 5.51256C6.34075 5.18437 6.78587 5 7.25 5H7.5V4.5C7.5 4.36739 7.55268 4.24021 7.64645 4.14645C7.74022 4.05268 7.86739 4 8 4C8.13261 4 8.25979 4.05268 8.35356 4.14645C8.44732 4.24021 8.5 4.36739 8.5 4.5V5H9.5C9.63261 5 9.75979 5.05268 9.85356 5.14645C9.94732 5.24021 10 5.36739 10 5.5C10 5.63261 9.94732 5.75979 9.85356 5.85355C9.75979 5.94732 9.63261 6 9.5 6H7.25C7.05109 6 6.86032 6.07902 6.71967 6.21967C6.57902 6.36032 6.5 6.55109 6.5 6.75C6.5 6.94891 6.57902 7.13968 6.71967 7.28033C6.86032 7.42098 7.05109 7.5 7.25 7.5H8.75C9.21413 7.5 9.65925 7.68437 9.98744 8.01256C10.3156 8.34075 10.5 8.78587 10.5 9.25Z"
            fill="#099831"
          />
        </svg>
        <h2 class="heading-h2">Investimentos</h2>
      </div>

      <div class="patrimony__content">
        <div class="content-grid">
          <div>
            <h3 class="heading-h3">Já possui investimentos</h3>
            <p class="paragraph">{{ investiments }}</p>
          </div>

          <div *ngIf="dataStoreInvestiments.investments" class="anotation">
            <h3 class="heading-h3">Valor de portfólio atual</h3>
            <p class="paragraph">{{ amountCurrentPortfolioFormated }}</p>
          </div>

          <div *ngIf="dataStoreInvestiments.investments">
            <h3 class="heading-h3">Sabe quanto paga ao assessor(a)</h3>
            <p class="paragraph">{{ accessorPayment }}</p>
          </div>

          <div *ngIf="dataStoreInvestiments.investments">
            <h3 class="heading-h3">
              Você gostaria de conhecer o modelo de gestão de investimentos mais
              bem-sucedido do mundo?
            </h3>
            <p class="paragraph">{{ investimentsInterest }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
